// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-step-editor-sidebar[data-v-32295e4c]{border-left:1px solid #e5e8ec;overflow:auto}", ""]);
// Exports
module.exports = exports;
